import React from 'react';
import SalesDeals from '../modules/SalesDeals';

function SalesDealsPage(){
  return <SalesDeals/>
}

export default SalesDealsPage;
